import { Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Slider, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNetwork } from "../../providers/NetworkProvider";
import { useSnackbar } from "../../providers/SnackbarProvider";
import { useAuth } from "../../providers/AuthenticationProvider";
import { getStorage,  ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { useFirebase } from "../../providers/FirebaseProvider";


export const AddAnalysis = () => {
	const [newTraderUid, setNewTraderUid] = useState<string>("");
	const [side, setSide] = useState<string>("");
	const [symbols, setSymbol] = useState<string[]>([]);
	const [accuracy, setAccuracy] = useState<number>(0);
	const [title, setTitle] = useState<string>("");
	const [message, setMessage] = useState<string>("");
	const [timeframe, setTimeframe] = useState<string>("");
	const [timestamp, setTimestamp] = useState<number | null>(null);

	const { makePost } = useNetwork();
	const { openLoadingSnackbar, closeLoadingSnackbar, openSnackbar } =
		useSnackbar();
	const { user } = useAuth();
	const [images, setImages] = useState<File[]>([]);
	const { myFS, myApp } = useFirebase();
	const fileInputRef = React.createRef();

	const storage = getStorage(myApp);


	const handleNewTraderUidChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		setNewTraderUid(event.target.value);
	};

	const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
		const files = e.target.files;
		if (files) {
			const filesArray = Array.from(files);
			setImages(filesArray);
		}
	};

	const handleMakeTrader = async () => {
		if (user == null) return;
		openLoadingSnackbar();
		try {
			const tokenId = await user.getIdToken();
			const imageUrls: string[] = [];
			for (const image of images) {
				console.log(`Analisys/${newTraderUid}/${image.name}`);

				const imageRef = storageRef(storage, `/Analisys/${newTraderUid}/${image.name}`);
				await uploadBytes(imageRef, image);
				const url = await getDownloadURL(imageRef);
				console.log("url", url);
				imageUrls.push(url);
			}
			const analysisDataToSend = {
				images: imageUrls,
				side: side,
				symbols: symbols,
				accuracy: accuracy,
				title: title,
				message: message,
				timeframe: timeframe,
				timestamp: timestamp
			}	
			console.log(analysisDataToSend);

			const res = await makePost(
				"admin/addAnalysisAdmin",
				{
					analysisData: analysisDataToSend,
					traderUid: "7bwICCWJNaThMa06dXcl2Ww9EbI3"
				},tokenId
			);
			console.log(res);
			if (res.status === 200) {
				openSnackbar(
					"Success",
					"The user has been made a trader",
					"success"
				);
			} else {

				throw new Error("something went wrong");
			}
		} catch (err) {
			const error = err as Error;
			console.log(err);
			openSnackbar("Error", error.message, "error");
			console.error(err);
		}
		closeLoadingSnackbar();
	};
	const handleClick = () => {
		(fileInputRef.current as any).click();
	};
	const handlePostSubmit = async () => {
		openLoadingSnackbar();
		try {
			// Upload multiple images to Firebase Storage


			// Check if user already exists
			//make post

			setImages([]);
			openSnackbar("Foto caricate", "", "success");
			// window.location.reload();
		} catch (error) {
			console.error("Error submitting post:", error);
			openSnackbar("Errore", "", "error");
		}
		closeLoadingSnackbar();
	};

	const handleChange = (event: SelectChangeEvent) => {
		setSide(event.target.value as string);
	};


	const handleSetSymbols = (event: React.ChangeEvent<HTMLInputElement>) => {
		let completeSymbol = event.target.value as string;
		let arraySymbol = [
			completeSymbol.slice(0, 3),
			completeSymbol.slice(3, 6)
		];
		setSymbol(arraySymbol);
		console.log(arraySymbol);
	}

	const handleSetTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTitle(event.target.value as string);
	}

	const handleSetMessage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setMessage(event.target.value as string);
	}

	const handleSetTimeframe = (event: SelectChangeEvent) => {
		setTimeframe(event.target.value as string);
	}

	const handleSetTimestamp = (event: React.ChangeEvent<HTMLInputElement>) => {
		let temp_timestamp = (Number(event.target.value) == 0) ? null : Number(event.target.value);
		setTimestamp(temp_timestamp);
	}

	return (
		<>
			<Stack
				spacing={2}
				sx={{ maxWidth: 440, margin: "auto", display: "block" }}
			>
				<h3>Add Analysis</h3>
				<input
					id="fileInput"
					type="file"
					ref={fileInputRef as any}
					onChange={handleImageUpload}
					multiple
					style={{ display: "none" }}
				/>
				<Button onClick={handleClick} sx={{ marginTop: "16px" }}>
					<Typography
						variant="h5"
						fontSize="28px"
						fontFamily="Work Sans"
						sx={{
							background: "transparent",
							padding: "8px",
							borderRadius: "8px",
							border: "2px solid #fff",
							color: "#fff",
							fontSize: "16px"
						}}
					>
						Add image
					</Typography>
				</Button>

				<TextField
					id="uid"
					label="uid"
					color="primary"
					fullWidth
					value={newTraderUid}
					onChange={handleNewTraderUidChange}
				/>


				<FormControl fullWidth>

					<InputLabel id="demo-simple-select-label">Side</InputLabel>
					<Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						label="Side"
						value={side}
						onChange={handleChange}
					>
						<MenuItem value={"BUY"}>Buy</MenuItem>
						<MenuItem value={"SELL"}>Sell</MenuItem>
					</Select>
				</FormControl>

				<TextField
					id="symbols"
					label="symbols"
					color="primary"
					fullWidth
					value={symbols.join("")}
					onChange={handleSetSymbols}
				/>

				<Typography style={{
					color: "#fff"
				}}>Accuracy</Typography>
				<Slider defaultValue={accuracy}
					onChange={(event, value) => {
						setAccuracy(value as number);
						console.log(accuracy);
					}} aria-label="Default" color="secondary" valueLabelDisplay="auto" />

				<TextField
					id="title"
					label="title"
					color="primary"
					fullWidth
					value={title}
					onChange={handleSetTitle}
				/>

				<TextField
					id="message"
					label="message"
					color="primary"
					fullWidth
					value={message}
					onChange={handleSetMessage}
				/>


				<FormControl fullWidth>

					<InputLabel id="demo-simple-select-label">Timeframe</InputLabel>
					<Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						label="Side"
						value={timeframe}
						onChange={handleSetTimeframe}
					>
						<MenuItem value={"M1"}>M1</MenuItem>
						<MenuItem value={"M5"}>M5</MenuItem>
						<MenuItem value={"M15"}>M15</MenuItem>
						<MenuItem value={"M30"}>M30</MenuItem>
						<MenuItem value={"H1"}>H1</MenuItem>
						<MenuItem value={"H4"}>H4</MenuItem>
						<MenuItem value={"D1"}>D1</MenuItem>
						<MenuItem value={"W1"}>W1</MenuItem>
						<MenuItem value={"MN"}>MN</MenuItem>
					</Select>
				</FormControl>

				<TextField
					id="timestamp"
					label="Timestamp (optional)"
					color="primary"
					fullWidth
					value={timestamp}
					onChange={handleSetTimestamp}
				/>



				<Button
					variant="contained"
					color="secondary"
					onClick={handleMakeTrader}
					size="large"
					fullWidth
					sx={{
						height: "55px",
						textTransform: "none",
						fontFamily: "Work Sans !important",
					}}
				>
					Add Analysis
				</Button>
			</Stack>
		</>
	);

}
export default AddAnalysis;
